/* Mendwell cookie consent — granular, opt-in, no dark patterns.
   Categories: necessary (always on), analytics, marketing.
   Persists choice in localStorage; surfaces a settings re-opener via [data-mw-cc-open]. */
(function () {
  'use strict';
  var KEY = 'mw_cookie_consent_v1';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save(state) {
    try { localStorage.setItem(KEY, JSON.stringify(Object.assign({ts: Date.now()}, state))); } catch (e) {}
    apply(state);
    document.dispatchEvent(new CustomEvent('mendwell:consent', {detail: state}));
  }
  function apply(state) {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!state.analytics,
          marketing: !!state.marketing,
          preferences: !!state.preferences,
          sale_of_data: false
        }, function () {});
      } catch (e) {}
    }
  }

  function open(banner) { banner.classList.add('is-open'); banner.removeAttribute('hidden'); }
  function close(banner) { banner.classList.remove('is-open'); banner.setAttribute('hidden',''); }

  function init() {
    var banner = document.querySelector('[data-mw-cc]');
    if (!banner) return;

    // Toggle expand
    banner.querySelector('[data-mw-cc-customize]').addEventListener('click', function () {
      banner.classList.toggle('is-expanded');
    });

    // Toggles (analytics, marketing, preferences)
    banner.querySelectorAll('[data-mw-cc-toggle]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.hasAttribute('disabled')) return;
        var on = t.getAttribute('aria-checked') === 'true';
        t.setAttribute('aria-checked', on ? 'false' : 'true');
      });
    });

    function readState() {
      return {
        necessary: true,
        analytics: banner.querySelector('[data-mw-cc-toggle="analytics"]').getAttribute('aria-checked') === 'true',
        marketing: banner.querySelector('[data-mw-cc-toggle="marketing"]').getAttribute('aria-checked') === 'true',
        preferences: banner.querySelector('[data-mw-cc-toggle="preferences"]').getAttribute('aria-checked') === 'true'
      };
    }

    banner.querySelector('[data-mw-cc-accept-all]').addEventListener('click', function () {
      banner.querySelectorAll('[data-mw-cc-toggle]').forEach(function (t) { if (!t.hasAttribute('disabled')) t.setAttribute('aria-checked','true'); });
      save(readState());
      close(banner);
    });
    banner.querySelector('[data-mw-cc-reject-all]').addEventListener('click', function () {
      banner.querySelectorAll('[data-mw-cc-toggle]').forEach(function (t) { if (!t.hasAttribute('disabled')) t.setAttribute('aria-checked','false'); });
      save({necessary: true, analytics: false, marketing: false, preferences: false});
      close(banner);
    });
    banner.querySelector('[data-mw-cc-save]').addEventListener('click', function () {
      save(readState());
      close(banner);
    });

    // Re-opener
    document.querySelectorAll('[data-mw-cc-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(banner); });
    });

    var stored = load();
    if (!stored) {
      // First visit: show banner, defaults all off (no pre-selected accept)
      requestAnimationFrame(function () { open(banner); });
    } else {
      apply(stored);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
